import { handlePriceByComma } from "@/helpers/common/handlePrice";
import { validatePrice } from "@/helpers/product";
import { useTranslation } from "next-i18next";
import CurrencyIcon from "../icons/CurrencyIcon";

const Price = ({ productWithConfigurations, product }) => {
  const { t } = useTranslation("common");

  const priceWithTax = productWithConfigurations
    ? productWithConfigurations?.prices_with_tax
    : product?.prices_with_tax;
  const price = validatePrice(priceWithTax);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <p className="flex items-center gap-1 font-bold text-secondary-800 sm:text-xl">
          {handlePriceByComma(price?.specialPrice || price?.originalPrice)}{" "}
          <CurrencyIcon className="size-5" />
        </p>
        {price?.specialPrice ? (
          <p className="flex items-center gap-1 font-medium line-through text-zinc-400 sm:text-xl">
            {handlePriceByComma(price?.originalPrice)}{" "}
            <CurrencyIcon className="size-5" />
          </p>
        ) : null}
      </div>
      {price?.specialPrice ? (
        <div className="flex items-center gap-2 max-sm:text-xs">
          {/* <SARIcon /> */}
          <span className="flex items-center gap-1 font-bold text-red-600">
            {t("Save money")}{" "}
            {(price?.originalPrice - price?.specialPrice)?.toFixed(2)}{" "}
            <CurrencyIcon className="size-5" />
          </span>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Price;
